var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPerformingArts = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Show-Theater-Masks--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Show Theater Masks Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.07 5a18 18 0 0 0 6.69 0.72 0.25 0.25 0 0 0 0.24 -0.25V1a1 1 0 0 0 -1.37 -0.93c-3.44 1.4 -10.82 1.4 -14.26 0A1 1 0 0 0 0 1v6.75c0 3.58 2.76 6.73 5.23 8.5a0.28 0.28 0 0 0 0.29 0 0.27 0.27 0 0 0 0.1 -0.27 8.9 8.9 0 0 1 -0.2 -1.86v-6A3.38 3.38 0 0 1 10.07 5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.17 6.58a1.9 1.9 0 0 0 -1.76 -0.19c-2.84 1.15 -9.07 1.15 -11.9 0a1.9 1.9 0 0 0 -1.76 0.19 1.87 1.87 0 0 0 -0.83 1.56v6c0 5.39 6.2 9.87 8.54 9.87S24 19.52 24 14.13v-6a1.87 1.87 0 0 0 -0.83 -1.55ZM22 14.13c0 4.24 -5.3 7.87 -6.54 7.87s-6.54 -3.63 -6.54 -7.87V8.66a0.23 0.23 0 0 1 0.1 -0.2 0.24 0.24 0 0 1 0.23 0 23.78 23.78 0 0 0 12.42 0 0.24 0.24 0 0 1 0.23 0 0.26 0.26 0 0 1 0.1 0.2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.45 16.11a0.74 0.74 0 0 0 -1 0.27 2.27 2.27 0 0 1 -3.94 0 0.75 0.75 0 0 0 -1 -0.27 0.74 0.74 0 0 0 -0.27 1 3.77 3.77 0 0 0 6.54 0 0.75 0.75 0 0 0 -0.33 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.29 10.75a2.25 2.25 0 0 0 -2.12 1.5 0.75 0.75 0 1 0 1.41 0.5 0.76 0.76 0 0 1 0.71 -0.5 0.75 0.75 0 0 1 0.71 0.5 0.75 0.75 0 0 0 0.71 0.5 0.73 0.73 0 0 0 0.25 0 0.76 0.76 0 0 0 0.46 -1 2.26 2.26 0 0 0 -2.13 -1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.33 12.75a0.75 0.75 0 0 0 0.71 0.5 0.73 0.73 0 0 0 0.25 0 0.76 0.76 0 0 0 0.46 -1 2.26 2.26 0 0 0 -4.25 0 0.75 0.75 0 0 0 0.46 1 0.76 0.76 0 0 0 1 -0.46 0.75 0.75 0 0 1 1.41 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPerformingArts);
export default ForwardRef;